import { Dispatch, MouseEvent, SetStateAction } from 'react';
import { SubAssembly } from '../../../services/rawProd/rawProd.types';

export enum RawProdFlows {
  'addNew',
  'addLikeNation',
  'edit',
}

export interface RawProdFormProps {
  flow: RawProdFlows;
  formValues: RawProdFormValues;
  formErrors?: RawProdFormErrors;
  setFormValues: Dispatch<SetStateAction<RawProdFormValues>>;
  setFormErrors?: Dispatch<SetStateAction<RawProdFormErrors>>;
  headerTitle: string;
  selectedSubassemblyRawProds: SubAssembly[];
  setSelectedSubassemblyRawProds: Dispatch<SetStateAction<SubAssembly[]>>;
  saveDisabled: boolean;
  handleSave: (event: MouseEvent) => void;
  disabledInputs?: string[];
  isButtonLoading?: boolean;
}

export interface RawProdFormValues {
  id?: number;
  mxRef?: string;
  moaRawProdNo?: number;
  rawProdNo?: number;
  rawProdTpCode?: string;
  description: string;
  shortDescription: string;
  statusNo?: number;
  classNo?: number;
  printSeq?: number;
  pcaNo?: number;
  occasionNo?: number;
  invenUomNo?: number;
  prodUomNo?: number;
  conversionFactor?: number;
  buyLocal?: boolean;
  accountCode: string;
  newAccountCode: string;
  usageAlgorithm: string;
  frozen?: boolean;
  safetyPolicy?: number;
  glAccountingCode?: string;
  glAccountCategoryDescription?: string;
  updatedDate?: string;
  updatedBy?: string;
}
export interface RawProdFormErrors {
  mxRef?: string;
  moaRawProdNo?: string;
  rawProdNo?: string;
  rawProdTpCode?: string;
  description?: string;
  shortDescription?: string;
  statusNo?: string;
  classNo?: string;
  printSeq?: string;
  pcaNo?: string;
  occasionNo?: string;
  invenUomNo?: string;
  prodUomNo?: string;
  conversionFactor?: string;
  buyLocal?: string;
  accountCode?: string;
  newAccountCode?: string;
  usageAlgorithm?: string;
  frozen?: string;
  safetyPolicy?: string;
  glAccountingCode?: string;
  glAccountCategoryDescription?: string;
  updatedDate?: string;
  updatedBy?: string;
}
